import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalizeLoader, GuiFacade } from '@app/store/gui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, of, switchMap, tap } from 'rxjs';
import { productsSyncActions } from '../actions/products-sync.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class ProductsSyncEffects {
    private readonly actions$ = inject(Actions);
    private readonly httpService = inject(HttpService);
    private readonly guiFacade = inject(GuiFacade);

    syncItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(productsSyncActions.syncItems),
            concatMap(() =>
                this.httpService.syncItems().pipe(
                    tap(() => this.guiFacade.showSuccessMessage('PRODUCTS.ITEMS.TOAST.sync_start')),
                    map(() => productsSyncActions.syncItemsSuccess()),
                    catchError((error: HttpErrorResponse) => of(productsSyncActions.syncItemsError({ code: error.status }))),
                    finalizeLoader(this.guiFacade, 'products-sync'),
                ),
            ),
        );
    });

    getSyncStatus$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(productsSyncActions.getSyncStatus),
            switchMap(() =>
                this.httpService.syncStatus().pipe(
                    tap((payload) => {
                        if (payload.status === 'failed') {
                            this.guiFacade.showSuccessMessage(payload.error ?? 'PRODUCTS.ITEMS.TOAST.sync_failed');
                        }
                        if (payload.status === 'completed') {
                            this.guiFacade.showSuccessMessage('PRODUCTS.ITEMS.TOAST.sync_completed');
                        }
                    }),
                    map((payload) => productsSyncActions.getSyncStatusSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(productsSyncActions.getSyncStatusError({ code: error.status }))),
                ),
            ),
        );
    });

    getSyncStatusQuiet$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(productsSyncActions.getSyncStatusQuiet),
            switchMap(() =>
                this.httpService.syncStatus().pipe(
                    map((payload) => productsSyncActions.getSyncStatusQuietSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(productsSyncActions.getSyncStatusQuietError({ code: error.status }))),
                ),
            ),
        );
    });
}
